<script lang="ts">
  let {
    open = $bindable(false),
    title = "Контакт",
    name = "",
    phone = "",
    onsave,
  }: {
    open?: boolean;
    title?: string;
    name?: string;
    phone?: string;
    onsave?: (v: { name: string; phone: string }) => Promise<boolean>;
  } = $props();

  let n = $state("");
  let p = $state("");
  let saving = $state(false);

  $effect(() => {
    if (open) { n = name; p = phone; }
  });

  const canSave = $derived(!saving && (!!n.trim() || !!p.trim()));

  function close() {
    if (!saving) open = false;
  }

  async function save() {
    if (!canSave) return;
    saving = true;
    const ok = (await onsave?.({ name: n.trim(), phone: p.trim() })) ?? true;
    saving = false;
    if (ok) open = false;
  }
</script>

{#if open}
  <div class="backdrop" onclick={close} role="presentation"></div>
  <div class="sheet" role="dialog" aria-label={title}>
    <div class="grab"></div>
    <div class="title">{title}</div>
    <label>
      <span class="lbl">Имя</span>
      <input bind:value={n} placeholder="Карина" autocomplete="off" />
    </label>
    <label>
      <span class="lbl">Телефон</span>
      <input bind:value={p} type="tel" inputmode="tel" placeholder="+7 925 …" autocomplete="off" />
    </label>
    <div class="actions">
      <button class="btn ghost" onclick={close} type="button" disabled={saving}>Отмена</button>
      <button class="btn primary" onclick={save} type="button" disabled={!canSave}>
        {saving ? "Сохраняю…" : "Сохранить в amoCRM"}
      </button>
    </div>
  </div>
{/if}

<style>
  .backdrop { position: fixed; inset: 0; background: rgba(0,0,0,0.5); z-index: 60; animation: fade 160ms ease; }
  .sheet {
    position: fixed; left: 0; right: 0; bottom: 0;
    max-width: 480px; margin: 0 auto;
    background: var(--bg-elev);
    border-top-left-radius: 22px; border-top-right-radius: 22px;
    padding: 12px 18px calc(18px + var(--safe-bottom, 0px));
    box-shadow: var(--shadow-lg);
    z-index: 70;
    animation: slide 220ms cubic-bezier(.18,.89,.32,1.05);
  }
  .grab { width: 36px; height: 4px; background: var(--border-strong); border-radius: 2px; margin: 0 auto 12px; }
  .title { font-family: 'Manrope', sans-serif; font-weight: 700; font-size: 15px; color: var(--text); margin-bottom: 4px; }
  label { display: block; }
  .lbl {
    display: block; font-size: 11px; color: var(--text-dim);
    text-transform: uppercase; letter-spacing: 0.08em; font-weight: 600;
    margin-top: 12px; margin-bottom: 6px;
  }
  input {
    width: 100%; box-sizing: border-box;
    background: var(--bg-elev-2); border: 1px solid var(--border); border-radius: 10px;
    padding: 10px 12px; color: var(--text); font-family: inherit; font-size: 16px;
  }
  input:focus { border-color: var(--ember); outline: none; }
  .actions { display: grid; grid-template-columns: 1fr 1.6fr; gap: 8px; margin-top: 16px; }
  .btn {
    height: 46px; border-radius: 12px;
    font-family: 'Manrope', sans-serif; font-weight: 600; font-size: 14px;
    cursor: pointer; transition: transform 120ms;
  }
  .btn:active:not(:disabled) { transform: scale(0.97); }
  .btn.ghost { background: var(--bg-elev-2); color: var(--text); border: 1px solid var(--border); }
  .btn.primary { background: var(--ember); color: #fff; border: none; box-shadow: var(--shadow-sm); }
  .btn:disabled { opacity: 0.4; cursor: not-allowed; }
  @keyframes fade { from { opacity: 0; } to { opacity: 1; } }
  @keyframes slide { from { transform: translateY(100%); } to { transform: translateY(0); } }
  @media (prefers-reduced-motion: reduce) { .backdrop, .sheet { animation: none; } }
</style>
